import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { Formik } from "formik";
import * as Yup from "yup";
import { createBusinessBottom, getBusinessBottom, updateBusinessBottom } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import { showToast } from "../../../Utills/toast";
import FormGroup from "../../Common/FormGroup";

const validationSchema = Yup.object({
  paragraph: Yup.string()
    .required("Bottom title is required")
});

export default function BottomParagraphEdit() {
  const { id, partnerId } = useParams();
  const navigate = useNavigate();

  const [bottom, setBottom] = useState({ paragraph: '' });
  const [saving, setSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const getInitialValues = () => ({
    paragraph: bottom.paragraph || ""
  });

  const fetchBottomData = async () => {
    setIsLoading(true);
    if (!Number(id)) {
      setIsLoading(false);
      return;
    }

    try {
      const response = await getBusinessBottom(id);
      const bottomData = response.data.data[0];
      setBottom(bottomData);
      console.log(response.data.data[0]);
    } catch (error) {
      console.log(error);
      showToast({
        type: 'error',
        message: error?.response?.data?.message || "Failed to fetch bottom title data. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBottomData();
  }, [id]);

  const handleSubmit = async (values,) => {
    setSaving(true);

    const formData = {
      paragraph: values.paragraph,
    };

    if (!Number(id)) {
      formData.partner_id = partnerId;
      try {
        const response = await createBusinessBottom(formData);
        console.log(response);
        if (response.status === 200) {
          showToast({
            type: 'success',
            message: response?.data?.message || "Bottom title section has been created successfully!",
          });
          const headerData = response?.data?.data;
          setBottom(headerData);
          if (headerData && headerData.id) {
            navigate(`/${partnerId}/forbusiness/bottomtitle/edit/${headerData.id}`);
          }
          console.log("success");
        } else {
          showToast({
            type: 'error',
            message: response?.data?.message || "Failed to create bottom title section. Please try again.",
          });
        }
      } catch (error) {
        showToast({
          type: 'error',
          message: error?.response?.data?.message || "Failed to create bottom title section. Please try again.",
        });
        console.log(error);
      } finally {
        setSaving(false);
      }
    } else {
      try {
        const response = await updateBusinessBottom(id, formData);
        console.log(response);
        if (response.status === 200) {
          showToast({
            type: 'success',
            message: response?.data?.message || "Bottom title section has been updated successfully!",
          });
          console.log("success");
        } else {
          showToast({
            type: 'error',
            message: response?.data?.message || "Failed to update bottom title section. Please try again.",
          });
        }
      } catch (error) {
        console.log(error);
        showToast({
          type: 'error',
          message: error?.response?.data?.message || "Failed to update bottom title section. Please try again.",
        });
      } finally {
        setSaving(false);
      }
    }
  };

  return (
    <>
      {isLoading ? (
        <CmsCircularProgress />
      ) : (
        <FormWrapper>
          <Title>{Number(id) ? 'Edit' : 'Add'} Bottom Title Section</Title>
          <SliderDiv>
            <Formik
              initialValues={getInitialValues()}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize={true}
            >
              {({
                values,
                errors,
                touched,
                handleSubmit,
                handleChange,
                handleBlur,
                isSubmitting,
              }) => (
                <Form noValidate onSubmit={handleSubmit}>
                  <FormGroup 
                    label='Enter a bottom title' 
                    requiredField
                    error={touched.paragraph && errors.paragraph ? errors.paragraph : ''}
                  >
                    <Form.Control
                      as="textarea"
                      rows={2}
                      name="paragraph"
                      value={values.paragraph}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Enter bottom title here..."
                      isInvalid={touched.paragraph && !!errors.paragraph}
                    />
                  </FormGroup>
                  <ButtonWrapper className="mt-3">
                    <Link to={`/${partnerId}/forbusiness/bottomtitle/view/${id}`}>
                      <Button variant="secondary" className="w-100">Go Back</Button>
                    </Link>
                    <Button
                      variant="primary"
                      type="submit"
                      disabled={saving || isSubmitting}
                      className="w-100"
                    >
                      {saving ? "Saving..." : "Save Changes"}
                    </Button>
                  </ButtonWrapper>
                </Form>
              )}
            </Formik>
          </SliderDiv>
        </FormWrapper>
      )}
    </>
  );
}

const FormWrapper = styled.div`
  @media (min-width:576px) {
    padding: 1rem;
  }
  @media (min-width:768px) {
    padding: 1.5rem;
  }
  padding: .5rem;
`;

const Title = styled.h3`
  text-align: center;
  padding: 10px 0;
`;

const ButtonWrapper = styled.div`
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5rem;
  @media (max-width: 890px) {
    gap: 2rem;
  }
  @media (max-width: 425px) {
    gap: 1rem;
  }
`;

const SliderDiv = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;
